// extracted by mini-css-extract-plugin
export var articlePreview = "wnWJT";
export var categoryLink = "-axkj";
export var content = "kbA2n";
export var contentOverflowContainer = "feKzY";
export var contentRatioContainer = "WTakR";
export var excerpt = "zvI1n";
export var image = "_6LYUW";
export var imagePlaceholder = "BKXku";
export var title = "Fzr0o";